import moment from 'moment';

export const minEffectiveDateValidator = (value, valueGetter) => {
  const effectiveDate = valueGetter('effectiveDate');
  let formattedEffectiveDate = moment(effectiveDate).format('YYYY-MM-DD');
  if (moment(value).isBefore(formattedEffectiveDate) && value !== undefined) {
    return 'Expiration Date cannot be set before Effective Date';
  }
  return '';
};
